module.exports = __webpack_public_path__ + "img/win_line.1ae409df.png";